module.exports = __webpack_public_path__ + "f096b44df6c96100a9a274ff57666f3a.svg";